export const unwrapData = (response) => response?.data ?? {}

export const normalizeSearchHistory = (data) => {
  return Array.isArray(data) ? data : []
}
